<template>
<tr>
  <td><v-select :options="items" label="Name" @input="setItem" v-model="selectedItem"></v-select></td>
  <td><textarea cols="20" rows="10" v-model="item.Description" class="form-control"></textarea></td>
  <td><input class="form-control" type="number" v-model.number="quantity"></td>
  <td>
    <input
      class="form-control" type="number"
      v-model="item.SalesDetails.UnitPrice"
      v-if="item.SalesDetails">
  </td>
  <td>
    <v-select :options="accounts" label="Name" index="Code" v-model="item.SalesDetails.AccountCode" v-if="item.SalesDetails"></v-select>
  </td>
  <td></td>
  <td>
    <v-select :options="departments[0].Options" label="Name" index="Name" @change="setTracking" v-if="departments.length" v-model="item.department"></v-select>
  </td>
  <td>
    {{ calculatedPrice }}
  </td>
  <td>
    <a><i class="fa fa-remove red" @click="deleteItem"></i></a>
  </td>
</tr>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      item: {
        Tracking: [],
        quantity: 1,
        SalesDetails: {}
      },
      quantity: 1,
      data: {},
      selectedItem: null
    }
  },
  computed: {
    calculatedPrice: function () {
      console.log(this.item.SalesDetails, this.quantity)
      if (!this.item.SalesDetails) return null
      return (parseInt(this.quantity) || 1) * parseInt(this.item.SalesDetails.UnitPrice)
    },
    ...mapGetters({
      departments: 'getXeroCategories'
    })
  },
  created () {
    if (!this.departments.length) {
      this.$store.dispatch('fetchXeroCategories')
    }
    if (this.existingInvoice.LineItems) {
      if (this.existingInvoice.LineItems[this.index]) {
        let item = this.existingInvoice.LineItems[this.index]
        this.quantity = item.Quantity || 1
        this.item.SalesDetails.AccountCode = item.AccountCode
        this.item.Description = item.Description
        this.item.LineItemID = item.LineItemID
        this.item.SalesDetails.UnitPrice = item.LineAmount
        this.item.Code = item.Item.Code
        if (item.Tracking.length) {
          this.item.department = item.Tracking[0].Option
          this.setTracking(item.Tracking[0].Option)
        }
        if (item.Item) {
          this.selectedItem = this.items.filter(i => i.Code === item.Item.Code)
        }
      }
    }
  },
  name: 'InvoiceItem',
  props: ['items', 'accounts', 'index', 'existingInvoice'],
  watch: {
    item: {
      handler () {
        this.updateItem()
      },
      deep: true
    },
    quantity: function () {
      this.updateItem()
    }
  },
  methods: {
    updateItem () {
      this.$emit('itemUpdate', {index: this.index, item: this.item, quantity: this.quantity})
    },
    setItem (e) {
      this.item = e
    },
    setTracking (e) {
      this.item.Tracking = [{
        Option: e,
        Name: 'Department'
      }]
    },
    deleteItem () {
      if (!confirm('Do you want to delete this item?')) {
        return
      }
      this.$emit('itemDelete', this.index)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Billing/Tabs/Billing/InvoiceItem.vue